import { render, staticRenderFns } from "./AddServiceCompany.vue?vue&type=template&id=c500f36c&"
import script from "./AddServiceCompany.vue?vue&type=script&lang=ts&"
export * from "./AddServiceCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports